import { useEffect, useRef } from 'react';
import SignaturePadLib from 'signature_pad';

export const SignaturePad = ({
  onSignatureChange,
}: {
  onSignatureChange: (dataUrl: string) => void;
}) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const signaturePadRef = useRef<SignaturePadLib | null>(null);

  useEffect(() => {
    const canvas = canvasRef.current!;

    if (!signaturePadRef.current) {
      signaturePadRef.current = new SignaturePadLib(canvas, {});

      signaturePadRef.current.addEventListener('endStroke', () => {
        onSignatureChange(signaturePadRef.current!.toDataURL());
      });

      const onWindowResize = () => resizeCanvas(canvas);

      window.addEventListener('resize', onWindowResize);

      // For the initial size
      resizeCanvas(canvas);

      return () => {
        window.removeEventListener('resize', onWindowResize);
      };
    }
  }, [canvasRef, signaturePadRef, onSignatureChange]);

  return (
    <canvas
      id="signature_canvas"
      ref={canvasRef}
      style={{
        width: '100%',
        height: '100%',
      }}
    />
  );
};

function resizeCanvas(canvas: HTMLCanvasElement) {
  // The following lines makes the canvas "crisp" and "sharp" on high DPI screens
  // by scaling the canvas to the device pixel ratio
  const ratio = Math.max(window.devicePixelRatio || 1, 1);

  canvas.width = canvas.offsetWidth * ratio;
  canvas.height = canvas.offsetHeight * ratio;
  canvas.getContext('2d')?.scale(ratio, ratio);
}
